module.exports = __webpack_public_path__ + "img/symbol_15_normal.7cfc8076.png";